import { useState } from "react";
import { Flex } from "@chakra-ui/react"; // Add these imports
import { useTable, useSortBy } from "react-table";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import { textLightBlue, newBorder } from "../../../utils/colors"; // Assuming colors
// import { useTranslation } from "react-i18next";
import useThemeColors from "../../../hooks/useThemeColors";
// import useCurrencySymbol from "../../../hooks/useCurrencySymbol";

const TreatmentPlansServicesTablePublic = ({
  loading,

  columns,
  data,
  className,

  onRowClick,
  sortField,
  sortOrder,
  isHeaderWhite,

  newTableItemId,
}) => {
  // const { t } = useTranslation();
  const { whiteMode, bgLightMode, hoverItemColorMode } = useThemeColors();

  // STATE
  const [sortState, setSortState] = useState({ sortField, sortOrder });

  // Update to generate sorting indicators manually based on sortState
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  // Update to generate sorting indicators manually based on sortState
  const generateSortingIndicator = (columnId) => {
    return sortState.sortField === columnId ? (
      sortState.sortOrder === "desc" ? (
        <TriangleDownIcon aria-label="sorted descending" />
      ) : (
        <TriangleUpIcon aria-label="sorted ascending" />
      )
    ) : null;
  };

  // Example function to handle sort change (if you want to implement sorting changes via UI)
  const handleSortChange = (columnId) => {
    const isAsc =
      sortState.sortField === columnId && sortState.sortOrder === "asc";
    const newSortOrder = isAsc ? "desc" : "asc";
    setSortState({ sortField: columnId, sortOrder: newSortOrder });
    // Here you would trigger the data fetch based on new sort criteria
  };

  // You can add a new condition here to handle the case when the data length is zero
  if (!data || (data.length === 0 && !loading)) {
    return <>{<Flex>fasfsa</Flex>}</>;
  }

  // Example function to handle row click
  const handleRowClick = (e, rowId) => {
    // Exclude clicks on input elements like switches or buttons
    if (!["INPUT", "BUTTON"].includes(e.target.tagName)) {
      onRowClick(rowId);
    }
  };

  // LOGS

  // console.log("loading", loading);
  // console.log("error", error);
  // console.log("data", data);
  // console.log("columns", columns);

  return (
    <>
      <Flex w="100%" overflowX={["scroll", "hidden", "hidden"]}>
        <Table {...getTableProps()} className={className} w="100%">
          <Thead
            style={{
              pointerEvents: "none",
            }}
          >
            {headerGroups.map((headerGroup) => {
              // Extract the key and rest of the props
              const headerGroupProps = headerGroup.getHeaderGroupProps();
              const { key: headerGroupKey, ...restHeaderGroupProps } =
                headerGroupProps;

              return (
                <Tr key={headerGroupKey} {...restHeaderGroupProps}>
                  {headerGroup.headers.map((column) => {
                    // Extract the key and rest of the props
                    const columnProps = column.getHeaderProps(
                      column.getSortByToggleProps()
                    );
                    const { key: columnKey, ...restColumnProps } = columnProps;

                    return (
                      <Th
                        key={columnKey}
                        {...restColumnProps}
                        bg={isHeaderWhite ? whiteMode : bgLightMode}
                        color={textLightBlue}
                        h="2rem"
                        fontSize="xs"
                        fontWeight="500"
                        borderBottom={
                          isHeaderWhite ? `1px solid ${newBorder}` : "none"
                        }
                        p="0.25rem 0.5rem"
                        onClick={() => handleSortChange(column.id)}
                        textTransform="capitalize"
                      >
                        <Flex align="center" h="100%">
                          {column.render("Header")}
                          {generateSortingIndicator(column.id)}
                        </Flex>
                      </Th>
                    );
                  })}
                </Tr>
              );
            })}
          </Thead>

          <Tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              // Extract the key and rest of the props
              const rowProps = row.getRowProps();
              const { key: rowKey, ...restRowProps } = rowProps;

              return (
                <Tr
                  key={rowKey}
                  {...restRowProps}
                  onClick={(e) => handleRowClick(e, row.original._id)}
                  bg={row.original._id === newTableItemId ? "#ffffce" : "none"}
                  _hover={{ bg: hoverItemColorMode, cursor: "default" }}
                  p="0"
                >
                  {row.cells.map((cell) => {
                    // Extract the key and rest of the props
                    const cellProps = cell.getCellProps();
                    const { key: cellKey, ...restCellProps } = cellProps;

                    return (
                      <Td key={cellKey} {...restCellProps} p="0.5rem 0.5rem">
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Flex>
    </>
  );
};

export default TreatmentPlansServicesTablePublic;
